import type {
	ApiResponse,
	ProviderOperationsSearchResponse,
	ProviderOperationsSearchRowResponse,
} from "libs/apiClient";
import { getProviderOperationsRowKey } from "./getProviderOperationsRowKey";

export function replaceProviderOperationsRows(
	searchResult: ApiResponse<ProviderOperationsSearchResponse> | undefined,
	updatedRows: ProviderOperationsSearchRowResponse[],
): ApiResponse<ProviderOperationsSearchResponse> | undefined {
	if (searchResult === undefined) {
		return undefined;
	}

	const updatedRowsByKey = new Map(updatedRows.map((row) => [getProviderOperationsRowKey(row), row]));

	return {
		...searchResult,
		data: {
			...searchResult.data,
			rows: searchResult.data.rows.map((row) => updatedRowsByKey.get(getProviderOperationsRowKey(row)) ?? row),
		},
	};
}
